import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ConsoleContextService } from '@core/services/console-context.service';
import { SubscriptionDto } from '@stores/tenants';
import { IconComponent } from '@shared/icons/icon/icon.component';

@Component({
  selector: 'mtm-subscription-selector',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './subscription-selector.component.html',
  styleUrl: './subscription-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionSelectorComponent {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  readonly context = inject(ConsoleContextService);

  readonly isOpen = signal(false);

  readonly selected = computed(() => this.context.selectedSubscription());
  readonly options = computed(() => this.context.selectedTenant()?.subscriptions ?? []);

  toggleOpen(): void {
    this.isOpen.set(!this.isOpen());
  }

  onSelect(subscription: SubscriptionDto): void {
    this.context.selectSubscription(subscription);
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocClick(event: MouseEvent): void {
    const target = event.target as Node | null;
    if (!target) return;
    if (!this.elementRef.nativeElement.contains(target)) {
      this.isOpen.set(false);
    }
  }
}
